import { useRoutes } from "react-router";
import { getRoutes } from "routes";

const App = () => {
  return useRoutes(getRoutes());
};

export default App;
